import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from '../../mui-styles-bridge.js';
import TextField from '@mui/material/TextField';
import {
  getValidationHelperText,
  validatePattern,
} from '../../utils/inputValidation';

const styles = (theme) => ({
  textroot: {
    width: 272,
    margin: 'auto',
  },
  input: {
    fontSize: 14,
  },
  root: {
    '& label.Mui-focused': {},

    '& .MuiOutlinedInput-root': {
      '& input': {
        paddingTop: 10,
        paddingBottom: 8,
        paddingLeft: 24,
      },
      '& fieldset': {},
      '&:hover fieldset': {
        borderColor: '#2196F3',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#2196F3',
      },
    },
  },
});

class NumberInput extends React.Component {
  constructor(props) {
    super(props);
    this.textFieldRef = React.createRef();
    // Store the wheel handler as an instance method to ensure proper cleanup
    this.handleWheel = (e) => e.preventDefault();
    this.state = {
      answer: '',
    };
  }

  componentDidMount() {
    if (this.textFieldRef.current)
      this.textFieldRef.current.addEventListener('wheel', this.handleWheel);

    let answer_data = this.props.form.answer_data[this.props.data.key];
    if (answer_data && answer_data.answer) {
      this.setState({
        answer: this.props.form.answer_data[this.props.data.key].answer[0],
      });
    } else {
      if (this.props.data.data.toString() && this.state.answer == '') {
        this.props.getDataFromComponent(
          { number_answer: this.props.data.data.toString() },
          this.props.data.key,
          this.props.data.question_text,
          this.props.data.data
        );
        this.setState({ answer: this.props.data.data });
      }
      if (
        this.props.data.auto.toString() &&
        !this.props.form.answer_data[this.props.data.key]
      ) {
        this.props.getDataFromComponent(
          { number_answer: this.props.data.auto.toString() },
          this.props.data.key,
          this.props.data.question_text,
          this.props.data.data
        );
        this.setState({ answer: this.props.data.auto });
      }
    }
  }

  componentWillUnmount() {
    if (this.textFieldRef.current)
      this.textFieldRef.current.removeEventListener('wheel', this.handleWheel);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.data.data != prevProps.data.data) {
      this.props.getDataFromComponent(
        { number_answer: this.props.data.data.toString() },
        this.props.data.key,
        this.props.data.question_text,
        this.props.data.data
      );
      this.setState({ answer: this.props.data.data });
    }
  }

  handleOnChange = (event) => {
    this.setState({ answer: event.target.value });
  };

  handleOnBlur = (event) => {
    let text = { number_answer: event.target.value };
    this.props.getDataFromComponent(
      text,
      this.props.data.key,
      this.props.data.question_text,
      this.props.data.data
    );
  };

  render() {
    const { classes, data } = this.props;

    try {
      return (
        <div
          onScroll={(event) => {
            event.preventDefault();
          }}
          onWheel={(event) => {
            event.preventDefault();
          }}
          className={classes.root}
        >
            <TextField
              onScroll={(event) => event.currentTarget.blur()}
              onWheel={(event) => event.currentTarget.blur()}
              value={this.state.answer || ''}
              id="free-text-input"
              className={classes.textroot}
              InputProps={{
                className: classes.input,
                inputProps:
                  typeof this.props.data.style === 'object'
                    ? this.props.data.style
                    : {},
              }}
              ref={this.textFieldRef}
              step="any"
              disabled={this.props.data.read_only}
              type="number"
              placeholder={typeof this.props.data.data === 'object' ? this.props.data.data.placeholder : undefined}
              variant="outlined"
              label={typeof this.props.data.data === 'object' ? this.props.data.data.label : undefined}
              onChange={
                this.props.data.read_only == 'true' ? '' : this.handleOnChange
              }
              onBlur={
                this.props.data.read_only == 'true' ? '' : this.handleOnBlur
              }
              error={
                !validatePattern(
                  this.state.answer,
                  this.props.data.validation,
                  'number'
                )
              }
              helperText={getValidationHelperText(
                this.state.answer,
                this.props.data.validation,
                'number'
              )}
            />
        </div>
      );
    } catch (e) {
      return <h5>Error encountered</h5>;
    }
  }
}

const mapStateToProps = (state, props) => {
  return {
    form: state.form,
  };
};

const mapDispatchToProps = {};

NumberInput.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(NumberInput));
